import script from "./CheckboxButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckboxButton.vue?vue&type=script&lang=ts&setup=true"

import "./CheckboxButton.vue?vue&type=style&index=0&id=fdea6000&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdea6000"]])

export default __exports__